import { useImpersonationError, useUserActions } from 'stores/useUserStore';

import MultiLineText from 'components/core/typography/MultiLineText';
import { StructuredDialog } from 'components/ui/dialogs/StructuredDialog';
import { ErrorIcon } from 'components/ui/icons';
import { translate } from 'utils/intlUtils';

import { RED_500 } from 'styles/tokens';

const ImpersonationError = () => {
  const impersonationError = useImpersonationError();
  const { clearImpersonationError } = useUserActions();

  const isOpen = impersonationError !== undefined;

  return (
    <StructuredDialog
      header={translate.t('cannot_login_as_user')}
      icon={<ErrorIcon color={RED_500} height={72} width={72} />}
      isOpen={isOpen}
      onClose={clearImpersonationError}
    >
      <MultiLineText>{impersonationError}</MultiLineText>
    </StructuredDialog>
  );
};

export default ImpersonationError;
